export const INSPECTIONS_MODAL = 'INSPECTIONS_MODAL';

export const setInspectionsModal = (state) => (dispatch) => {
    dispatch({ type: INSPECTIONS_MODAL, state });
};

export default {
    INSPECTIONS_MODAL,
    setInspectionsModal,
};
